import { render, staticRenderFns } from "./VesselsPrint.vue?vue&type=template&id=aa8761b0&"
import script from "./VesselsPrint.vue?vue&type=script&lang=js&"
export * from "./VesselsPrint.vue?vue&type=script&lang=js&"
import style0 from "./VesselsPrint.vue?vue&type=style&index=0&id=aa8761b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports